import { createRouter, createWebHistory } from 'vue-router'
import SocialMediaEnricherView from "@/views/SocialMediaEnricherView.vue";
import YoutubeView from "@/views/YoutubeView.vue";
import YoutubeTranscriptView from "@/views/YoutubeTranscriptView.vue";
import YoutubeLightView from "@/views/RelevancyCheckView.vue";
import IntentTracker from "@/views/IntentTracker.vue";
import ValidTargetsView from "@/views/ValidTargetsView.vue";
import MagicClipsView from "@/views/MagicClipsView.vue";
import MainLayout from "@/layouts/MainLayout.vue";
import HostsGuestsView from "@/views/HostsGuestsView.vue";
import UseCasesView from "@/views/UseCasesView.vue";
import CompetitorsTargetsView from "@/views/CompetitorsTargetsView.vue";
import CoWorkersView from "@/views/CoWorkersView.vue";
import ApolloEndpointsView from "@/views/ApolloEndpointsView.vue";
import IcpView from "@/views/IcpView.vue";
import SerpQuery from "@/views/SerpQueryView.vue";
import PersonalizedEmailsView from "@/views/PersonalizedEmailsView.vue";
import RedditView from '@/views/RedditView.vue';
import PersonalizedEmailsViewV2 from "@/views/PersonalizedEmailsViewV2.vue";
import PersonalizedEmailsViewV3 from "@/views/PersonalizedEmailsViewV3.vue";
import PersonalizedEmailsChurnView from '@/views/PersonalizedEmailsChurnView.vue';
import WinBackViewV1 from "@/views/WinBackViewV1.vue";
import WinBackViewV2 from "@/views/WinBackViewV2.vue";
import WinBackViewV3 from "@/views/WinBackViewV3.vue";
import ScriptGeneratorView from '@/views/ScriptGeneratorView.vue';
import LoginView from "@/views/LoginView.vue";
import YoutubeThumbnailView from '@/views/YoutubeThumbnailView.vue';
import CoverArtGeneratorView from '@/views/CoverArtGeneratorView.vue';
import store from '../store';
import PodcastChartsView from '@/views/PodcastChartsView.vue';
import AyeletEmailsView from '@/views/AyeletEmailsView.vue';

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/',
    component: MainLayout,
    meta: { auth: true },
    children: [
      {
        path: '',
        redirect: '/youtube'
      },
      {
        path: '/youtube',
        name: 'youtube',
        component: YoutubeView
      },
      {
        path: '/youtube-transcript',
        name: 'youtube-transcript',
        component: YoutubeTranscriptView
      },
      {
        path: '/youtube-light',
        name: 'youtube-light',
        component: YoutubeLightView
      },
      {
        path: '/sm-enricher',
        name: 'sm-enricher',
        component: SocialMediaEnricherView
      },
      {
        path: '/intent-tracker',
        name: 'intent-tracker',
        component: IntentTracker
      },
      {
        path: '/serp-query',
        name: 'serp-query',
        component: SerpQuery
      },
      {
        path: '/valid-targets',
        name: 'valid-targets',
        component: ValidTargetsView
      },
      {
        path: '/competitors',
        name: 'competitors',
        component: CompetitorsTargetsView
      },
      {
        path: '/co-workers',
        name: 'co-workers',
        component: CoWorkersView
      },
      {
        path: '/hosts-guests',
        name: 'hosts-guests',
        component: HostsGuestsView
      },
      {
        path: '/use-cases',
        name: 'use-cases',
        component: UseCasesView
      },
      {
        path: '/apollo-endpoints',
        name: 'apollo-endpoints',
        component: ApolloEndpointsView
      },
      {
        path: '/icp',
        name: 'icp',
        component: IcpView
      },
      {
        path: '/ayelet-emails',
        name: 'ayelet-emails',
        component: AyeletEmailsView
      },
      {
        path: '/personalized-emails',
        name: 'personalized-emails',
        component: PersonalizedEmailsView
      },
      {
        path: '/personalized-emails-v2',
        name: 'personalized-emails-v2',
        component: PersonalizedEmailsViewV2
      },
      {
        path: '/personalized-emails-v3',
        name: 'personalized-emails-v3',
        component: PersonalizedEmailsViewV3
      },
      {
        path: '/personalized-emails-churn',
        name: 'personalized-emails-churn',
        component: PersonalizedEmailsChurnView
      },
      {
        path: '/win-back-took-2-months-off',
        name: 'win-back-took-2-months-off',
        component: WinBackViewV1
      },
      {
        path: '/win-back-didnt-take-2-months',
        name: 'win-back-didnt-take-2-months',
        component: WinBackViewV2
      },
      {
        path: '/win-back-cancelled-past',
        name: 'win-back-cancelled-past',
        component: WinBackViewV3
      },
      {
        path: '/reddit',
        name: 'reddit',
        component: RedditView
      },
      {
        path: '/script-generator',
        name: 'script-generator',
        component: ScriptGeneratorView
      },
      {
        path: '/youtube-thumbnail',
        name: 'youtube-thumbnail',
        component: YoutubeThumbnailView
      },
      {
        path: '/cover-art-generator',
        name: 'cover-art-generator',
        component: CoverArtGeneratorView
      },
      {
        path: '/podcast-charts',
        name: 'podcast-charts',
        component: PodcastChartsView
      },
    ]
  },
  {
    path: '/magic-clips/:id',
    name: 'magic-clips',
    meta: { auth: true },
    component: MagicClipsView
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async ({ params, meta, name: route }, from, next) => {
  if (route === 'login') {
    return next();
  }
  meta?.auth && !store.state.auth.user?.name
    ? await store.dispatch('get_user', next)
    : next();
});

export default router
